"use strict";

var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StreamMessage_1 = __importDefault(require("../protocol/message_layer/StreamMessage"));

var StreamMessageError_1 = __importDefault(require("../errors/StreamMessageError"));

var ValidationError_1 = __importDefault(require("../errors/ValidationError"));

var GroupKeyRequest_1 = __importDefault(require("../protocol/message_layer/GroupKeyRequest"));

var GroupKeyMessage_1 = __importDefault(require("../protocol/message_layer/GroupKeyMessage"));

var SigningUtil_1 = __importDefault(require("./SigningUtil"));

var StreamID_1 = require("./StreamID");

var PUBLIC_USER = '0x0000000000000000000000000000000000000000';
/**
 * Validates observed StreamMessages according to protocol rules, regardless of observer.
 * Functions needed for external interactions are injected as constructor args.
 *
 * The recoverAddressFn function could be imported from eg. ethers, but it would explode the bundle size, so
 * better leave it up to whoever is the end user of this class to choose which library they use.
 *
 * Note that most checks can not be performed for unsigned messages. Checking message integrity is impossible,
 * and checking permissions would require knowing the identity of the publisher, so it can't be done here.
 *
 * TODO later: support for unsigned messages can be removed when deprecated system-wide.
 */

var StreamMessageValidator = /*#__PURE__*/function () {
  /**
   * @param getStream async function(streamId): returns the metadata required for stream validation for streamId.
   *        The included fields should be at least: { partitions, requireSignedData }
   * @param isPublisher async function(address, streamId): returns true if address is a permitted publisher on streamId
   * @param isSubscriber async function(address, streamId): returns true if address is a permitted subscriber on streamId
   * @param verify async function(address, payload, signature): returns true if the address and payload match the signature.
   * @param requireBrubeckValidation whether to enable brubeck validation rules
   * The default implementation uses the native secp256k1 library on node.js and falls back to the elliptic library on browsers.
   */
  function StreamMessageValidator(_ref) {
    var getStream = _ref.getStream,
        isPublisher = _ref.isPublisher,
        isSubscriber = _ref.isSubscriber,
        _ref$verify = _ref.verify,
        verify = _ref$verify === void 0 ? SigningUtil_1.default.verify : _ref$verify,
        _ref$requireBrubeckVa = _ref.requireBrubeckValidation,
        requireBrubeckValidation = _ref$requireBrubeckVa === void 0 ? false : _ref$requireBrubeckVa;

    _classCallCheck(this, StreamMessageValidator);

    StreamMessageValidator.checkInjectedFunctions(getStream, isPublisher, isSubscriber, verify);
    this.getStream = getStream;
    this.isPublisher = isPublisher;
    this.isSubscriber = isSubscriber;
    this.verify = verify;
    this.requireBrubeckValidation = requireBrubeckValidation;
  }

  _createClass(StreamMessageValidator, [{
    key: "validate",
    value:
    /**
     * Checks that the given StreamMessage is satisfies the requirements of the protocol.
     * This includes checking permissions as well as signature. The method supports all
     * message types defined by the protocol.
     *
     * Resolves the promise if the message is valid, rejects otherwise.
     *
     * @param streamMessage the StreamMessage to validate.
     */
    function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(streamMessage) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (streamMessage) {
                  _context.next = 2;
                  break;
                }

                throw new ValidationError_1.default('Falsey argument passed to validate()!');

              case 2:
                _context.t0 = streamMessage.messageType;
                _context.next = _context.t0 === StreamMessage_1.default.MESSAGE_TYPES.MESSAGE ? 5 : _context.t0 === StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_REQUEST ? 6 : _context.t0 === StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_ANNOUNCE ? 7 : _context.t0 === StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_RESPONSE ? 7 : _context.t0 === StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_ERROR_RESPONSE ? 7 : 8;
                break;

              case 5:
                return _context.abrupt("return", this.validateMessage(streamMessage));

              case 6:
                return _context.abrupt("return", this.validateGroupKeyRequest(streamMessage));

              case 7:
                return _context.abrupt("return", this.validateGroupKeyResponseOrAnnounce(streamMessage));

              case 8:
                throw new StreamMessageError_1.default("Unknown message type: ".concat(streamMessage.messageType, "!"), streamMessage);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate(_x) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     * Checks that the signature in the given StreamMessage is cryptographically valid.
     * Resolves if valid, rejects otherwise.
     *
     * It's left up to the user of this method to decide which implementation to pass in as the verifyFn.
     *
     * @param streamMessage the StreamMessage to validate.
     * @param verifyFn function(address, payload, signature): return true if the address and payload match the signature
     */

  }, {
    key: "validateMessage",
    value: function () {
      var _validateMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(streamMessage) {
        var stream, isPublicStream, sender, senderIsPublisher;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getStream(streamMessage.getStreamId());

              case 2:
                stream = _context2.sent;

                if (!((stream.requireSignedData || this.requireBrubeckValidation) && !streamMessage.signature)) {
                  _context2.next = 5;
                  break;
                }

                throw new StreamMessageError_1.default('Stream data is required to be signed.', streamMessage);

              case 5:
                if (!(streamMessage.encryptionType === StreamMessage_1.default.ENCRYPTION_TYPES.NONE)) {
                  _context2.next = 12;
                  break;
                }

                if (!this.requireBrubeckValidation) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return this.isSubscriber(PUBLIC_USER, streamMessage.getStreamId());

              case 9:
                isPublicStream = _context2.sent;

                if (isPublicStream) {
                  _context2.next = 12;
                  break;
                }

                throw new StreamMessageError_1.default('Non-public streams require data to be encrypted.', streamMessage);

              case 12:
                if (!(streamMessage.getStreamPartition() < 0 || streamMessage.getStreamPartition() >= stream.partitions)) {
                  _context2.next = 14;
                  break;
                }

                throw new StreamMessageError_1.default("Partition ".concat(streamMessage.getStreamPartition(), " is out of range (0..").concat(stream.partitions - 1, ")"), streamMessage);

              case 14:
                if (!streamMessage.signature) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 17;
                return StreamMessageValidator.assertSignatureIsValid(streamMessage, this.verify);

              case 17:
                sender = streamMessage.getPublisherId(); // Check that the sender of the message is a valid publisher of the stream

                _context2.next = 20;
                return this.isPublisher(sender, streamMessage.getStreamId());

              case 20:
                senderIsPublisher = _context2.sent;

                if (senderIsPublisher) {
                  _context2.next = 23;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(sender, " is not a publisher on stream ").concat(streamMessage.getStreamId(), "."), streamMessage);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validateMessage(_x2) {
        return _validateMessage.apply(this, arguments);
      }

      return validateMessage;
    }()
  }, {
    key: "validateGroupKeyRequest",
    value: function () {
      var _validateGroupKeyRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(streamMessage) {
        var groupKeyRequest, sender, recipient, recipientIsPublisher, senderIsSubscriber;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (streamMessage.signature) {
                  _context3.next = 2;
                  break;
                }

                throw new StreamMessageError_1.default("Received unsigned group key request (the public key must be signed to avoid MitM attacks).", streamMessage);

              case 2:
                if (StreamID_1.StreamIDUtils.isKeyExchangeStream(streamMessage.getStreamId())) {
                  _context3.next = 4;
                  break;
                }

                throw new StreamMessageError_1.default("Group key requests can only occur on stream ids of form ".concat("".concat(StreamID_1.StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX, "{address}"), "."), streamMessage);

              case 4:
                groupKeyRequest = GroupKeyRequest_1.default.fromStreamMessage(streamMessage);
                sender = streamMessage.getPublisherId();
                recipient = StreamID_1.StreamIDUtils.getRecipient(streamMessage.getStreamId());
                _context3.next = 9;
                return StreamMessageValidator.assertSignatureIsValid(streamMessage, this.verify);

              case 9:
                _context3.next = 11;
                return this.isPublisher(recipient, groupKeyRequest.streamId);

              case 11:
                recipientIsPublisher = _context3.sent;

                if (recipientIsPublisher) {
                  _context3.next = 14;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(recipient, " is not a publisher on stream ").concat(groupKeyRequest.streamId, "."), streamMessage);

              case 14:
                _context3.next = 16;
                return this.isSubscriber(sender, groupKeyRequest.streamId);

              case 16:
                senderIsSubscriber = _context3.sent;

                if (senderIsSubscriber) {
                  _context3.next = 19;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(sender, " is not a subscriber on stream ").concat(groupKeyRequest.streamId, "."), streamMessage);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validateGroupKeyRequest(_x3) {
        return _validateGroupKeyRequest.apply(this, arguments);
      }

      return validateGroupKeyRequest;
    }()
  }, {
    key: "validateGroupKeyResponseOrAnnounce",
    value: function () {
      var _validateGroupKeyResponseOrAnnounce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(streamMessage) {
        var groupKeyMessage, sender, senderIsPublisher, recipient, recipientIsSubscriber;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (streamMessage.signature) {
                  _context4.next = 2;
                  break;
                }

                throw new StreamMessageError_1.default("Received unsigned ".concat(streamMessage.messageType, " (it must be signed to avoid MitM attacks)."), streamMessage);

              case 2:
                if (StreamID_1.StreamIDUtils.isKeyExchangeStream(streamMessage.getStreamId())) {
                  _context4.next = 4;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(streamMessage.messageType, " can only occur on stream ids of form ", "".concat(StreamID_1.StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX, "{address}"), "."), streamMessage);

              case 4:
                _context4.next = 6;
                return StreamMessageValidator.assertSignatureIsValid(streamMessage, this.verify);

              case 6:
                groupKeyMessage = GroupKeyMessage_1.default.fromStreamMessage(streamMessage); // can be GroupKeyResponse or GroupKeyAnnounce, only streamId is read

                sender = streamMessage.getPublisherId(); // Check that the sender of the request is a valid publisher of the stream

                _context4.next = 10;
                return this.isPublisher(sender, groupKeyMessage.streamId);

              case 10:
                senderIsPublisher = _context4.sent;

                if (senderIsPublisher) {
                  _context4.next = 13;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(sender, " is not a publisher on stream ").concat(groupKeyMessage.streamId, ". ").concat(streamMessage.messageType), streamMessage);

              case 13:
                if (!(streamMessage.messageType !== StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_ERROR_RESPONSE)) {
                  _context4.next = 20;
                  break;
                }

                // permit publishers to send error responses to invalid subscribers
                recipient = StreamID_1.StreamIDUtils.getRecipient(streamMessage.getStreamId()); // Check that the recipient of the request is a valid subscriber of the stream

                _context4.next = 17;
                return this.isSubscriber(recipient, groupKeyMessage.streamId);

              case 17:
                recipientIsSubscriber = _context4.sent;

                if (recipientIsSubscriber) {
                  _context4.next = 20;
                  break;
                }

                throw new StreamMessageError_1.default("".concat(recipient, " is not a subscriber on stream ").concat(groupKeyMessage.streamId, ". ").concat(streamMessage.messageType), streamMessage);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateGroupKeyResponseOrAnnounce(_x4) {
        return _validateGroupKeyResponseOrAnnounce.apply(this, arguments);
      }

      return validateGroupKeyResponseOrAnnounce;
    }()
  }], [{
    key: "checkInjectedFunctions",
    value: function checkInjectedFunctions(getStream, isPublisher, isSubscriber, verify) {
      if (typeof getStream !== 'function') {
        throw new Error('getStream must be: async function(streamId): returns the validation metadata object for streamId');
      }

      if (typeof isPublisher !== 'function') {
        throw new Error('isPublisher must be: async function(address, streamId): returns true if address is a permitted publisher on streamId');
      }

      if (typeof isSubscriber !== 'function') {
        throw new Error('isSubscriber must be: async function(address, streamId): returns true if address is a permitted subscriber on streamId');
      }

      if (typeof verify !== 'function') {
        throw new Error('verify must be: function(address, payload, signature): returns true if the address and payload match the signature');
      }
    }
  }, {
    key: "assertSignatureIsValid",
    value: function () {
      var _assertSignatureIsValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(streamMessage, verifyFn) {
        var payload, success;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payload = streamMessage.getPayloadToSign();

                if (!(streamMessage.signatureType === StreamMessage_1.default.SIGNATURE_TYPES.ETH_LEGACY || streamMessage.signatureType === StreamMessage_1.default.SIGNATURE_TYPES.ETH)) {
                  _context5.next = 15;
                  break;
                }

                _context5.prev = 2;
                _context5.next = 5;
                return verifyFn(streamMessage.getPublisherId(), payload, streamMessage.signature);

              case 5:
                success = _context5.sent;
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
                throw new StreamMessageError_1.default("An error occurred during address recovery from signature: ".concat(_context5.t0), streamMessage);

              case 11:
                if (success) {
                  _context5.next = 13;
                  break;
                }

                throw new StreamMessageError_1.default('Signature validation failed', streamMessage);

              case 13:
                _context5.next = 16;
                break;

              case 15:
                throw new StreamMessageError_1.default("Unrecognized signature type: ".concat(streamMessage.signatureType), streamMessage);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 8]]);
      }));

      function assertSignatureIsValid(_x5, _x6) {
        return _assertSignatureIsValid.apply(this, arguments);
      }

      return assertSignatureIsValid;
    }()
  }]);

  return StreamMessageValidator;
}();

exports.default = StreamMessageValidator;